import { Component, OnInit } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { ServiceProviderService } from '../../Service/Service-providers/service-provider.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-promotion-analytics',
  templateUrl: './promotion-analytics.component.html',
  styleUrls: ['./promotion-analytics.component.scss']
})
export class PromotionAnalyticsComponent implements OnInit {

  constructor(private api: ServiceProviderService,
    private route: ActivatedRoute
  ) { }

  shouldHaveSidebar = false;
  rangeDates: any;

  views = { total: 0, unique: 0 };
  clicks = { total: 0, unique: 0 };
  conversations = { total: 0, unique: 0 };

  // Chart data
  dateChartLabels: string[] = [];
  dateChartData: any[] = [];

  brandChartLabels: string[] = [];
  brandChartData: any[] = [{
    data: [],
    label: 'Brands',
    backgroundColor: 'rgba(255, 165, 0, 0.2)',
    borderColor: 'rgba(255, 165, 0, 1)',
    borderWidth: 1
  }];

  chartOptions: ChartConfiguration['options'] = {
    responsive: true,
    scales: {
      x: {
        ticks: {
          color: '#000',
          font: {
            size: 12,
            weight: 'normal',
            family: 'Hanken Grotesk'
          }
        },
        grid: {
          display: false
        }
      },
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
          color: '#000',
        },
        grid: {
          display: false
        }
      },
    },
    plugins: {
      legend: { display: false },
    },
  };
  promotionId: number = 0;

  ngOnInit(): void {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    this.shouldHaveSidebar = user?.accessType !== 1;

    // promotionId from route
    this.route.paramMap.subscribe(params => {
      const id = params.get('promotionId');
      if (id) {
        this.promotionId = +id; 
        this.fetchAllAnalytics();      }
    });
  }

  onDateRangeChange() {
    if (this.rangeDates && this.rangeDates.length === 2) {
      const start = this.formatDate(this.rangeDates[0]);
      const end = this.formatDate(this.rangeDates[1]);
      const queryParams = `?StartDate=${start}&EndDate=${end}`;

      this.fetchAllAnalytics(queryParams);
    }
  }
  formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }
  fetchAllAnalytics(queryParams: string = '') {
    this.api.promotionViewCount(this.promotionId, queryParams).subscribe((res: any) => {
      this.views.total = res.totalViews;
      this.views.unique = res.uniqueViews;
    });

    this.api.promotionsGotoSpDetailsCount(this.promotionId, queryParams).subscribe((res: any) => {
      this.clicks.total = res.totalGoToSpClicks;
      this.clicks.unique = res.uniqueGoToSpClicks;
    });

    this.api.promotionChatCLicksCount(this.promotionId, queryParams).subscribe((res: any) => {
      this.conversations.total = res.totalOpenChatClicks;
      this.conversations.unique = res.uniqueOpenChatClicks;
    });

    this.api.promotionDaywiseClicksCount(this.promotionId, queryParams).subscribe((res: any) => {
      this.dateChartLabels = res.map((r: any) => {
        const date = new Date(r.day);
        return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
      });

      this.dateChartData = [
        {
          data: res.map((r: any) => r.count),
          label: 'Visits',
          backgroundColor: 'rgba(255, 165, 0, 0.2)',
          borderColor: 'rgba(255, 165, 0, 1)',
          borderWidth: 1
        }
      ];
    });

    this.api.promotionBrandwiseClicksCount(this.promotionId, queryParams).subscribe((res: any) => {
      this.brandChartLabels = res.map((r: any) => r.brandName || 'Unknown');
      this.brandChartData[0].data = res.map((r: any) => r.count);
    });
  }


}
